export default __webpack_public_path__ + "static/media/ISCO CLASS-5_SYLLABUS_2025-26.450333a4.pdf";